import { actionTypes } from '~/src/features/full-buy/store';

export const setDisplayTariffLineState = (displayState: boolean) => ({
    type: actionTypes.SET_DISPLAY_TARIFF_LINE_STATE,
    payload: {
        displayState,
    },
});
